import { createClient } from "@supabase/supabase-js";

const supabaseUrl =
  import.meta.env.VITE_PUBLIC_SUPABASE_URL ||
  "https://dorjzmtmmccgortrfyef.supabase.co";
const supabaseAnonKey =
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvcmp6bXRtbWNjZ29ydHJmeWVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1Nzg0ODksImV4cCI6MjA5MTE1NDQ4OX0.7H_masTCERJWAiTM4bm0A4hkJILxhxNUoyHf4pYb5jY";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Product = {
  id: string;
  name: string;
  description: string | null;
  short_description: string | null;
  image_url: string | null;
  category_id: string | null;
  sku: string | null;
  visible: boolean;
  featured: boolean;
  display_order: number;
  created_at: string;
};

export type Category = {
  id: string;
  name: string;
  slug: string;
  created_at: string;
};

export type Service = {
  id: string;
  name: string;
  description: string | null;
  icon: string | null;
  image_url: string | null;
  active: boolean;
  display_order: number;
  created_at: string;
};

export type Testimonial = {
  id: string;
  author: string;
  company: string | null;
  role: string | null;
  text: string;
  avatar_url: string | null;
  rating: number;
  active: boolean;
  display_order: number;
  created_at: string;
};

export type Case = {
  id: string;
  title: string;
  description: string | null;
  challenge: string | null;
  solution: string | null;
  image_url: string | null;
  category: string | null;
  client: string | null;
  year: number | null;
  active: boolean;
  display_order: number;
  created_at: string;
};

export type Banner = {
  id: string;
  title: string;
  subtitle: string | null;
  image_url: string | null;
  cta_label: string | null;
  cta_link: string | null;
  active: boolean;
  display_order: number;
  created_at: string;
};
